import React, { use, useEffect, useState, useTransition } from "react";
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import "./styles/Formulario_subirReporte.css";
import "./styles/estandar/ButtonStyles.css";
import MensajeError from '../components/MensajeError';
import axios from 'axios';
import styles from './styles/Estadisticas.module.css';

import BarChartCustom from '../components/BarChart';


import MenuBar from "../components/MenuBar";
import MenuHomeBox from "../components/MenuHomeBox";
import LogHomeBox from "../components/LogHomeBox";
import { validatePropertyDeps } from "ajv/dist/vocabularies/applicator/dependencies";
import Cookies from 'js-cookie';
import { MdFileUpload } from "react-icons/md";
import { IoMdArrowRoundBack } from "react-icons/io";
import { PiMicrosoftExcelLogoFill } from "react-icons/pi";
import { eventWrapper } from "@testing-library/user-event/dist/utils";
import loadingIcon from '../assets/img/loadico.png';
import { IoMdWarning } from "react-icons/io";
import { FaCheckCircle } from "react-icons/fa";

import { useConfig } from '../contexts/ConfigContext';


//RepPrNCA
const FormularioSubirReporte = () =>{
    const config = useConfig();
    const API_URL = `${config.API_URL}/api/registro/`;

    const [valor, setValor] = useState("Total");
    const [items, setItems] = useState([]);


     const navigate = useNavigate();

    //Mensajes de error:
    const [genericMensajeError, setGenericMensajeError] = useState('');
    const [showMensajeError, setShowMensajeError] = useState(false);
     

    /*Funcion para validar el tipo de session*/
    const [admin, setAdmin] = useState(false);
    const validarSesion = () =>{
            if(Cookies.get("turid")){
                const turid = Cookies.get("turid");
                if(turid === "rid1"){
                    setAdmin(true);
                }else if(turid !== "rid2"){
                    navigate("/");
                    Cookies.remove("usr");
                    Cookies.remove("turid");
                }
            }else{
                navigate("/");
                Cookies.remove("usr");
            }

    }
    useEffect(() =>{
        validarSesion();
        cargarEstadisitcas("Total")
    },[]);
    

    const handleCloseError = () => {
    setShowMensajeError(false); // Oculta el mensaje de error cuando el usuario hace clic en "Aceptar"
    setGenericMensajeError(''); // Opcional: limpia el mensaje de error
    window.location.reload(); 

    };


    const cargarEstadisitcas = async(nuevoValor) =>{
        setValor(nuevoValor);

          //Configuramos axios para que añada al header el respectivo token
        axios.interceptors.request.use(
        (config) => {
            const token = Cookies.get('usr');
            if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            console.error(error)
        }
        );

        const JSONPagina = {
             "valor": nuevoValor,
        }
        
        const cargarListaUsuarios = async () =>{
            try{
                const response = await axios.post(API_URL + "contabilizar", JSONPagina, {Authorization: true});
                if(response.status == 200){
                    const JSONResumen = response.data;
                    setItems(response.data);
                }else{
                    setGenericMensajeError(response.mensaje);
                    setShowMensajeError(true);
                }
                
            }catch(error){
                setGenericMensajeError(error);
                setShowMensajeError(true);
            }
        }

        cargarListaUsuarios();
    }

    return(
        <div className={styles.EMainHomeBox}>
            <MenuBar pagina="Relacion" sesion={admin}/>
            <MensajeError mensaje={genericMensajeError} show={showMensajeError} onClose={handleCloseError}/>
            <div className={styles.EmainHomeBody}>
                <h1 className={styles.titulo}>Estadísticas de registros</h1>
                <div className={styles.contenedor}>
                    <div className={styles.tablas}>
                        <div className={styles.opcionesBtn}>
                            <button className={valor === "Total" ? styles.activeBtn:styles.opcionBtn} onClick={(e) => {e.preventDefault(); cargarEstadisitcas("Total")}}>Total</button>
                            <button className={valor === "Año" ? styles.activeBtn:styles.opcionBtn} onClick={(e) => {e.preventDefault(); cargarEstadisitcas("Año")}}>Año</button>
                            <button className={valor === "Carrera" ? styles.activeBtn:styles.opcionBtn} onClick={(e) => {e.preventDefault(); cargarEstadisitcas("Carrera")}}>Carrera</button>
                            <button className={valor === "Prestatario" ? styles.activeBtn:styles.opcionBtn} onClick={(e) => {e.preventDefault(); cargarEstadisitcas("Prestatario")}}>Prestatario</button>
                            <button className={valor === "Area" ? styles.activeBtn:styles.opcionBtn} onClick={(e) => {e.preventDefault(); cargarEstadisitcas("Area")}}>Area</button>
                        </div>
                        <div className={styles.tablaContainer}>
                                                <BarChartCustom 
                            items={items} 
                            title={valor}
                            containerStyle={{ width: '60%', margin: '0 auto', height: '300px' }} 
                        />
                            <table className={styles.tabla}>
                                <thead className={styles.encabezadoTabla}>
                                    <tr>
                                    <th colSpan="2">{valor}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr className={styles.regTablaH} key="TITULOCAMPO">
                                            <td>Campo</td>
                                            <td>Total</td>
                                    </tr>
                                    {items.map((item) =>(
                                        <tr className={styles.regTabla} key={item.nombre}>
                                            <td>{item.nombre}</td>
                                            <td>{item.total}</td>
                                        </tr>
                                    ))}

                                </tbody>
                            </table>
                        </div>


                    </div>
                </div>
                  
            </div>

        </div>
            

    );
}

export default FormularioSubirReporte;